import React, { useContext,useState } from "react";
import { useSelector } from "react-redux";
import { runSplashScreenSelector , userNameSelector} from './../../selector/user.selector';
import { MenuWeb } from './menu-web.component';
import { Row , Col , Dropdown, Button  , Menu, Divider} from 'antd';
import { DeviceContext } from './../../components/device-provider/device-provider';
import { MenuMobile } from './menu-mobile.component';
import { MenuOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import { logoutAction } from './../../actions/user.action';
import { useDispatch } from 'react-redux';
import { showConfirm } from './../custom-components/custom-component';
import { WEB_RELEASE_VERSION } from './../../app.config';
import { LOGIN_ACCESS_TOKEN_KEY , SERVER_URL_ACCESS_TOKEN_KEY, LOGIN_USER_NAME_KEY, getAdminUrl, logoStyle} from './../../utils/constant';
import { removeLocalStorage } from './../../utils/utilities';
import qwikBusIcon from './../../images/qwikbus-logo.png';
import Icon from '@ant-design/icons';
import userIcon from './../../images/user-icon.png';
import { checkAgentsPage, checkAgentsTransactionPage, checkAgentLedgerPage, checkToViewServiceAccessPage, checkToViewServiceSharingPage, checkToViewBookingPartnersPage, checkToViewTripSheetPermissionPage, checkToViewUserActions, checkToViewSystemInfoPage } from "./app.header.module";
import { resetTripCreate } from "../../actions/trip-create.actions";


const { SubMenu } = Menu;

const getLogoUrl = () => {
    
    if(global.travelsDetails&&global.travelsDetails.agent_portal_logo){
        return global.travelsDetails.agent_portal_logo;
    }else{  
        return global.logoUrl || qwikBusIcon;
    }
};


export const AppHeader = () => {

    const {
        isMobile
    }=useContext(DeviceContext);

    const [visibleMenu,setVisibleMenu]=useState(false);

    let adminUrl = getAdminUrl();

    const onVisibleChange=(flag)=>{
        setVisibleMenu(flag);
    }

    const onMenuItemClick=(e)=>{
        setVisibleMenu(false);
    }

    const runSplashScreen=useSelector(runSplashScreenSelector);
    const userName =useSelector(userNameSelector);

    let history = useHistory();
    const dispatch = useDispatch();

    const dashboardClick=()=>{
        history.push("/dashboard");
    }

    const searchClick=()=>{
        history.push("/home");
    }
    
    const viewCancelClick=()=>{
        history.push("/view-cancel");
    }

    const changePassword=()=>{
        history.push("/change-password");
    }

    const serviceAccessPage=()=>{
        history.push("/users/service-access");
    }

    const serviceSharingPage=()=>{
        history.push("/users/service-sharing");
    }

    const bookingPartnersPage=()=>{
        history.push("/users/booking-partners");
    }

    const logout=()=>{
        showConfirm(()=>{
            removeLocalStorage(LOGIN_ACCESS_TOKEN_KEY);
            removeLocalStorage(SERVER_URL_ACCESS_TOKEN_KEY);
            removeLocalStorage(LOGIN_USER_NAME_KEY);
            dispatch(logoutAction());
        },"Log out Alert!","Do you want logout?");
    }

    const busCancelClick=()=>{
        history.push("/notify/bus-cancel");
    }


    const notificationClick=()=>{
        history.push("/notify/notification");
    }

    const onTripSheetClick=()=>{
        history.push("/report/tripsheet");
    }


    const onActiveBookingsClick=()=>{
        history.push("/report/viewActiveBookings");
    }

    const onBookedTicketsClick=()=>{
        history.push("/report/bookedtickets");
    }

    const onSalesReportClick=()=>{
        history.push("/report/salesreport");
    }

    const onSharedTripSalesReportClick=()=>{
        history.push("/report/sharedtripsales");
    }

    const onMasterAgentSalesReportClick=()=>{
        history.push("/report/masteragentsalesreport");
    }

    const onExpenseReportClick=()=>{
        history.push("/report/expense-report");
    }

    const onViewPassengerInfoReportClick=()=>{
        history.push("/report/viewpassengersreport");
    }

    const onBlockedReportClick=()=>{
        history.push("/report/blockedreport");
    }

    const onTicketSearchReportClick=()=>{
        history.push("/report/ticketsearchreport");
    }

    const onTicketSearchV2ReportClick=()=>{
        history.push("/view-ticket-search");
    }

    const onRescheduledTicketReportClick=()=>{
        history.push("/report/rescheduledTicketreport");
    }

    const onMasterTripSheetReport=()=>{
        history.push("/report/mastertripsheetreport");
    }

    const onClickSmsReport=()=>{
        history.push("/report/smsreport");
    }
    
    const performanceReport=()=>{
        history.push("/report/performancereport");
    }

    const totalTransactionReport=()=>{
        history.push("/report/totaltransactionreport");
    }

    const cancelledSeatsReportClick=()=>{
        history.push("/report/cancelledticketreport");
    }

    const viewAbandonedReportClick=()=>{
        history.push("/report/abandonedreport");
    }

    const webTicketSalesReportClick=()=>{
        history.push("/report/webticketsalesreport");
    }

    const webTicketCancelReportClick=()=>{
        history.push("/report/webticketcancelreport");
    }

    const onClickTicketsBookedAfterTripStartTime=()=>{
        history.push("/report/ticketbookedafterdeparture");
    }

    const onClickSettlementReport=()=>{
        history.push("/report/settlementreport");
    }

    const onClickGstFilingReport=()=>{
        history.push("/report/gstfilingreport");
    }

    const onClickDemandDataReport=()=>{
        history.push("/report/demandDataReport");
    }

    const onClickServiceCountReport=()=>{
        history.push("/report/viewServiceCountReport");
    }

    const onClickOccupancyReport=()=>{
        history.push("/report/occupancyReport");
    }

    const onClickCostSummaryReport=()=> {
        history.push("/report/costSummaryReport")
    }

    const onClickTransactionSummaryReport=()=> {
        history.push("/report/transactionSummaryReport")
    }

    const onClickTrackingSummaryReport=() => {
        history.push("/report/trackingSummaryReport")
    }

    const onClickAgentTransactionsPage = () =>{
        history.push("/accounts/agent-transactions");
    }

    const onClickAgentLedgerPage = () =>{
        history.push("/accounts/agent-ledger");
    }

    const onClickSystemInfoPage = () =>{
        history.push("/system-info");
    }

    const onClickAgentTripSheetPermissionPage = () =>{
        history.push("/accounts/trip-sheet-permission");
    }

    const onClickAgentsPage = () =>{
        history.push("/accounts/agents");
    }

    const tripCreatePage = () =>{
        dispatch(resetTripCreate());
        history.push("/trip-create");
    }

    const popularRoutesPage = () =>{
        history.push("/admin/popular-routes");
    }

    const userActionsPage = () =>{
        history.push("/admin/user-actions");
    }

    const operatorConfigClick = () =>{
        history.push("/admin/operatorconfig");
    }

    const qbccConfigClick = () =>{
        history.push("/admin/qbcc-config");
    }

    const busOperatorClick = () =>{
        history.push("/admin/bus-operator");
    }

    // All three deep-link to the same root page; hash decides the active tab.
    const settlementsGenerateClick = () => {
        history.push("/settlements#generate");
    }

    const settlementsHistoryClick = () => {
        history.push("/settlements#history");
    }

    const settlementsOpeningBalanceClick = () => {
        history.push("/settlements#opening");
    }

    const settlementBillingClick = () => {
        history.push("/settlement-billing");
    }

    const bookingConfigClick = () => {
        history.push("/admin/booking-config");
    }

    const billingConfigClick = () => {
        history.push("/admin/billing-config");
    }

    const colourConfigClick = () =>{
        history.push("/admin/colourconfig");
    }

    const operatorWebsiteConfigClick = () => {
        history.push("/admin/operator-website-config");
    }

    const expenseConfigClick = () =>{
        history.push("/admin/expenseconfig");
    }

    const discountConfigClick = () =>{
        history.push("/admin/discount-config");
    }

    const onClickCitiesPage = () =>{
        history.push("/admin/cities");
    }

    const onClickAddressBookPage = () =>{
        history.push("/admin/addressbook");
    }


    const openAdminTripsPage=()=>{
        // window.open(`${adminUrl}/trips`);
        history.push("/admin/trips")
    }

    const openBulkTripVehicleUpdatePage=()=>{
        history.push("/admin/bulk-trip-vehicle-update")
    }


    const openSchedulesPage=()=>{
        history.push("/admin/schedule");
    }

    const openAdminAgentsPage=()=>{
        history.push("/admin/users");
    }

    const openAdminVechicleManagementPage=()=>{
        history.push("/admin/vehicle-management");
    }

    const staffClick =()=>{
        history.push("/staff");
    }


    const onClickNewTrip =()=>{
        history.push("/new-trip")
    }

    const onClickStandardStops =()=>{
        history.push("/standard-stops")
    }

    const onClickTicketSharing =()=>{
        history.push("/report/ticketsharingreport")
    }

    const onClickRevenue =()=>{
        history.push("/report/revenuereport")
    }

    const onClickBusServiceCollectionReport =()=>{
        history.push("/report/busservicecollection")
    }

    const onClickTransactions =()=>{
        history.push("/report/prepaidtransactions")
    }

    const onClickDriverAttendanceReport =()=>{
        history.push("/report/driverAttendanceReport")
    }

    const onStopAnalysisReportClick =()=>{
        history.push("/report/stop-analysis")
    }

    const onPrepaidOTADashboardClick = () => {
        history.push("/prepaid-ota")
    }


    const navigateToHome=()=>{
        history.push("/home");
    }

    const preventDefault=(event)=>{
            event.preventDefault();
    }

    const renderMenuTxt=(txt,path)=>{
        return(
        <a href={path} onClick={preventDefault} target="_blank">{txt}</a>
        )
    }

    const onClickTemporaryChanges = () => {
        history.push("/admin/temporary-changes");
    }

    const openAdminBusesPage=()=>{
        history.push("/admin/buses");
    }

    const openCancellationPolicyPage=()=>{
        history.push("/admin/cancellation-policy");
    }

    const onClickOtaSearchPage = () => {
        history.push("/ota-search");
    }

    const openCoachTypesPage = () => {
        history.push("/admin/metadata/coach-types");
    }

    const openThemeColorsPage = () => {
        history.push("/admin/metadata/theme-colors");
    }

    const openRedbusCitiesPage = () => {
        history.push("/admin/redbus-cities");
    }

    const openTicketImportPage = () => {
        history.push("/admin/ticket-import");
    }

    if(runSplashScreen){
        return (
        <div className="menu-heading-title">
            <img src={getLogoUrl()} style={logoStyle} />
        </div>
        )
    }
    if(isMobile){
        return (
            <Row className="menu-heading-title" justify="space-between">
                <Col>
                    <Dropdown 
                    onVisibleChange={onVisibleChange}
                    visible={visibleMenu}
                    overlay={<MenuMobile 
                        userName={userName}
                        onClick={onMenuItemClick}
                        onTicketSearchReportClick={onTicketSearchReportClick}
                        onTicketSearchV2ReportClick={onTicketSearchV2ReportClick}
                        onRescheduledTicketReportClick = {onRescheduledTicketReportClick}
                        onMasterTripSheetReport={onMasterTripSheetReport}
                        onClickSmsReport={onClickSmsReport}
                        onViewPassengerInfoReportClick={onViewPassengerInfoReportClick}
                        onSalesReportClick={onSalesReportClick}
                        onSharedTripSalesReportClick={onSharedTripSalesReportClick}
                        onMasterAgentSalesReportClick={onMasterAgentSalesReportClick}
                        onExpenseReportClick={onExpenseReportClick}
                        onBookedTicketsClick={onBookedTicketsClick}
                        onTripSheetClick={onTripSheetClick}
                        notificationClick={notificationClick}
                        onBlockedReportClick={onBlockedReportClick}
                        logout={logout}
                        changePassword={changePassword}
                        viewCancelClick={viewCancelClick}
                        searchClick={searchClick}
                        busCancelClick={busCancelClick}
                        performanceReport={performanceReport}
                        totalTransactionReport={totalTransactionReport}
                        cancelledSeatsReportClick={cancelledSeatsReportClick}
                        viewAbandonedReportClick={viewAbandonedReportClick}
                        webTicketSalesReportClick={webTicketSalesReportClick}
                        webTicketCancelReportClick={webTicketCancelReportClick}
                        onClickTicketsBookedAfterTripStartTime={onClickTicketsBookedAfterTripStartTime}
                        onClickAgentTransactionsPage={onClickAgentTransactionsPage}
                        onClickAgentLedgerPage={onClickAgentLedgerPage}
                        onClickAgentTripSheetPermissionPage={onClickAgentTripSheetPermissionPage}
                        onClickAgentsPage={onClickAgentsPage}
                        onClickSettlementReport={onClickSettlementReport}
                        onClickGstFilingReport={onClickGstFilingReport}
                        onClickDemandDataReport={onClickDemandDataReport}
                        onClickServiceCountReport={onClickServiceCountReport}
                        onClickOccupancyReport={onClickOccupancyReport}
                        onClickCostSummaryReport={onClickCostSummaryReport}
                        onClickTransactionSummaryReport = {onClickTransactionSummaryReport}
                        onClickTrackingSummaryReport = {onClickTrackingSummaryReport}
                        openAdminTripsPage={openAdminTripsPage}
                        openBulkTripVehicleUpdatePage={openBulkTripVehicleUpdatePage}
                        onClickCitiesPage={onClickCitiesPage}
                        openSchedulesPage={openSchedulesPage}
                        openAdminAgentsPage={openAdminAgentsPage}
                        openAdminVechicleManagementPage={openAdminVechicleManagementPage}
                        staffClick={staffClick}
                        tripCreatePage = {tripCreatePage}
                        popularRoutesPage = {popularRoutesPage}
                        userActionsPage = {userActionsPage}
                        operatorConfigClick = {operatorConfigClick}
                        qbccConfigClick = {qbccConfigClick}
                        busOperatorClick = {busOperatorClick}
                        settlementsOpeningBalanceClick = {settlementsOpeningBalanceClick}
                        settlementsGenerateClick = {settlementsGenerateClick}
                        settlementsHistoryClick = {settlementsHistoryClick}
                        settlementBillingClick = {settlementBillingClick}
                        bookingConfigClick = {bookingConfigClick}
                        billingConfigClick = {billingConfigClick}
                        colourConfigClick = {colourConfigClick}
                        operatorWebsiteConfigClick = {operatorWebsiteConfigClick}
                        expenseConfigClick = {expenseConfigClick}
                        discountConfigClick = {discountConfigClick}
                        onClickNewTrip = {onClickNewTrip}
                        onClickStandardStops = {onClickStandardStops}
                        onClickTicketSharing = {onClickTicketSharing}
                        onClickRevenue = {onClickRevenue}
                        onClickBusServiceCollectionReport = {onClickBusServiceCollectionReport}
                        onClickTransactions = {onClickTransactions}
                        dashboardClick={dashboardClick}
                        onPrepaidOTADashboardClick = {onPrepaidOTADashboardClick}
                        onClickAddressBookPage = {onClickAddressBookPage}
                        serviceAccessPage = {serviceAccessPage}
                        checkToViewServiceAccessPage = {checkToViewServiceAccessPage}
                        serviceSharingPage = {serviceSharingPage}
                        checkToViewServiceSharingPage = {checkToViewServiceSharingPage}
                        bookingPartnersPage = {bookingPartnersPage}
                        checkToViewBookingPartnersPage = {checkToViewBookingPartnersPage}
                        onClickTemporaryChanges = {onClickTemporaryChanges}
                        openAdminBusesPage={openAdminBusesPage}
                        openCancellationPolicyPage={openCancellationPolicyPage}
                        onClickSystemInfoPage={onClickSystemInfoPage}
                        onClickOtaSearchPage={onClickOtaSearchPage}
                        onClickDriverAttendanceReport={onClickDriverAttendanceReport}
                        onStopAnalysisReportClick={onStopAnalysisReportClick}
                        openCoachTypesPage={openCoachTypesPage}
                        openThemeColorsPage={openThemeColorsPage}
                        openRedbusCitiesPage={openRedbusCitiesPage}
                        openTicketImportPage={openTicketImportPage}
                        />} trigger={['click','hover']}>
                            <MenuOutlined />
                    </Dropdown>
                </Col>     
                <Col>
                    <Button 
                    type="text" 
                    className="outline-button"  
                    onClick={navigateToHome}>
                        <img src={getLogoUrl()} style={logoStyle} />
                    </Button>
                </Col>     
            </Row>
        )
    }
    
    return (
        <Row className="menu-heading-title" justify="space-between"
        style={{ flexWrap: 'nowrap', alignItems: 'center' }}
        >
            <Col>
                <Button 
                type="text" 
                className="outline-button"  
                onClick={navigateToHome}>
                    <img src={getLogoUrl()} style={logoStyle} />
                </Button>
            </Col>     
            <Col flex="auto">
                <MenuWeb 
                    onClickAddressBookPage={onClickAddressBookPage}
                    onTicketSearchReportClick={onTicketSearchReportClick}
                    onTicketSearchV2ReportClick = {onTicketSearchV2ReportClick}
                    onRescheduledTicketReportClick = {onRescheduledTicketReportClick}
                    onMasterTripSheetReport={onMasterTripSheetReport}
                    onClickSmsReport={onClickSmsReport}
                    onViewPassengerInfoReportClick={onViewPassengerInfoReportClick}
                    onSalesReportClick={onSalesReportClick}
                    onSharedTripSalesReportClick={onSharedTripSalesReportClick}
                    onMasterAgentSalesReportClick={onMasterAgentSalesReportClick}
                    onExpenseReportClick={onExpenseReportClick}
                    onBookedTicketsClick={onBookedTicketsClick}
                    onTripSheetClick={onTripSheetClick}
                    onActiveBookingsClick={onActiveBookingsClick}
                    notificationClick={notificationClick}
                    logout={logout}
                    changePassword={changePassword}
                    viewCancelClick={viewCancelClick}
                    searchClick={searchClick}
                    busCancelClick={busCancelClick}
                    onBlockedReportClick={onBlockedReportClick}
                    performanceReport={performanceReport}
                    totalTransactionReport={totalTransactionReport}
                    cancelledSeatsReportClick={cancelledSeatsReportClick}
                    viewAbandonedReportClick={viewAbandonedReportClick}
                    webTicketSalesReportClick={webTicketSalesReportClick}
                    webTicketCancelReportClick={webTicketCancelReportClick}
                    onClickTicketsBookedAfterTripStartTime={onClickTicketsBookedAfterTripStartTime}
                    onClickAgentTransactionsPage={onClickAgentTransactionsPage}
                    onClickAgentLedgerPage={onClickAgentLedgerPage}
                    onClickAgentTripSheetPermissionPage={onClickAgentTripSheetPermissionPage}
                    onClickAgentsPage={onClickAgentsPage}
                    onClickSettlementReport={onClickSettlementReport}
                    onClickGstFilingReport={onClickGstFilingReport}
                    onClickDemandDataReport={onClickDemandDataReport}
                    onClickServiceCountReport={onClickServiceCountReport}
                    onClickOccupancyReport={onClickOccupancyReport}
                    onClickCostSummaryReport={onClickCostSummaryReport}
                    onClickTransactionSummaryReport = {onClickTransactionSummaryReport}
                    onClickTrackingSummaryReport = {onClickTrackingSummaryReport}
                    openAdminTripsPage={openAdminTripsPage}
                    openBulkTripVehicleUpdatePage={openBulkTripVehicleUpdatePage}
                    onClickCitiesPage={onClickCitiesPage}
                    openSchedulesPage={openSchedulesPage}
                    openAdminAgentsPage={openAdminAgentsPage}
                    openAdminVechicleManagementPage={openAdminVechicleManagementPage}
                    staffClick={staffClick}
                    tripCreatePage= {tripCreatePage}
                    popularRoutesPage = {popularRoutesPage}
                    userActionsPage = {userActionsPage}
                    operatorConfigClick = {operatorConfigClick}
                    qbccConfigClick = {qbccConfigClick}
                        busOperatorClick = {busOperatorClick}
                    settlementsOpeningBalanceClick = {settlementsOpeningBalanceClick}
                    settlementsGenerateClick = {settlementsGenerateClick}
                    settlementsHistoryClick = {settlementsHistoryClick}
                        settlementBillingClick = {settlementBillingClick}
                    bookingConfigClick = {bookingConfigClick}
                    billingConfigClick = {billingConfigClick}
                    colourConfigClick = {colourConfigClick}
                    operatorWebsiteConfigClick = {operatorWebsiteConfigClick}
                    expenseConfigClick = {expenseConfigClick}
                    discountConfigClick = {discountConfigClick}
                    onClickNewTrip = {onClickNewTrip}
                    onClickStandardStops = {onClickStandardStops}
                    onClickTicketSharing = {onClickTicketSharing}
                    onClickRevenue = {onClickRevenue}
                    onClickBusServiceCollectionReport = {onClickBusServiceCollectionReport}
                    onClickTransactions = {onClickTransactions}
                    dashboardClick={dashboardClick}
                    onPrepaidOTADashboardClick={onPrepaidOTADashboardClick}
                    onClickTemporaryChanges = {onClickTemporaryChanges}
                    openAdminBusesPage={openAdminBusesPage}
                    openCancellationPolicyPage={openCancellationPolicyPage}
                    onClickSystemInfoPage={onClickSystemInfoPage}
                    onClickOtaSearchPage={onClickOtaSearchPage}
                    onClickDriverAttendanceReport={onClickDriverAttendanceReport}
                    onStopAnalysisReportClick={onStopAnalysisReportClick}
                    openCoachTypesPage={openCoachTypesPage}
                    openThemeColorsPage={openThemeColorsPage}
                    openRedbusCitiesPage={openRedbusCitiesPage}
                    openTicketImportPage={openTicketImportPage}
                />
            </Col> 
            <Col>
                <Menu theme="dark" mode="horizontal" defaultSelectedKeys={[]} breakpoint="lg" collapsedWidth="0">
                    <SubMenu 
                    key="profile"
                    icon={<Icon component={() => (<img src={userIcon} className='user-icon' />)} />}>
                         {checkToViewUserActions()&&
                            <Menu.Item key= "/user-actions" onClick= {userActionsPage}>
                            {renderMenuTxt("Roles & Permissions","/user-actions")} 
                            </Menu.Item>
                        }
                        {checkToViewTripSheetPermissionPage()&&
                            <Menu.Item key="/accounts/trip-sheet-permission" onClick={onClickAgentTripSheetPermissionPage}>
                            {renderMenuTxt("Trip Sheet Permissions","/accounts/trip-sheet-permission")}
                            </Menu.Item>
                        }  
                        {checkToViewServiceAccessPage()&&
                            <Menu.Item key="/users/service-access" onClick={serviceAccessPage}>
                            {renderMenuTxt("Service Access","/users/service-access")}
                            </Menu.Item>
                        }
                        {checkToViewServiceSharingPage()&&
                            <Menu.Item key="/users/service-sharing" onClick={serviceSharingPage}>
                            {renderMenuTxt("Service Sharing","/users/service-sharing")}
                            </Menu.Item>
                        }
                        {checkToViewBookingPartnersPage()&&
                            <Menu.Item key="/users/booking-partners" onClick={bookingPartnersPage}>
                            {renderMenuTxt("Booking Partners","/users/booking-partners")}
                            </Menu.Item>
                        }
                         {checkAgentsPage()&&
                            <Menu.Item key="/accounts/agents" onClick={onClickAgentsPage}>
                            {renderMenuTxt("Agent Wallets","/accounts/agents")}
                            </Menu.Item>
                        }
                        {checkAgentsTransactionPage()&&
                            <Menu.Item key="/accounts/agent-transactions" onClick={onClickAgentTransactionsPage}>
                            {renderMenuTxt("Agent Transactions","/accounts/agent-transactions")}
                            </Menu.Item>
                        }
                        {checkAgentLedgerPage()&&
                            <Menu.Item key="/accounts/agent-ledger" onClick={onClickAgentLedgerPage}>
                            {renderMenuTxt("Agent Ledger","/accounts/agent-ledger")}
                            </Menu.Item>
                        }
                        <Divider />
                        {checkToViewSystemInfoPage()&&
                            <Menu.Item key="/system-info" onClick={onClickSystemInfoPage}>
                            {renderMenuTxt("System Info","/system-info")}
                            </Menu.Item>
                        }
                        <Menu.Item key="/change-password" onClick={changePassword}>
                            {renderMenuTxt("Change Password","/change-password")} 
                        </Menu.Item>
                        <Menu.Item key="/log-out" onClick={logout}>Logout</Menu.Item>
                    </SubMenu>
                </Menu>
            </Col>
            <Col>
                <Button className="header-version">{userName+" "+WEB_RELEASE_VERSION}</Button>
            </Col>           
        </Row>
    );
}